module.exports = __webpack_public_path__ + "img/undraw_secure_login_pdn4.383cc9f2.svg";